import { render, staticRenderFns } from "./IconManagement.vue?vue&type=template&id=6136c480&"
import script from "./IconManagement.vue?vue&type=script&lang=js&"
export * from "./IconManagement.vue?vue&type=script&lang=js&"
import style0 from "./IconManagement.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports